import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { PaymentConstants } from '../../shared/stripe-card-form/payment.constants';
import { MatchingGiftDialogData } from '../../shared/models/unlogged-donations/unlogged-donation-dialog-data.model';

@Component({
  selector: 'app-matching-gift-validate-dialog',
  templateUrl: './matching-gift-validate-dialog.component.html',
  styleUrls: ['./matching-gift-validate-dialog.component.scss']
})
export class MatchingGiftValidateDialogComponent {

  dialogData: MatchingGiftDialogData;
  constants = PaymentConstants;

  constructor(private dialogRef: MatDialogRef<MatchingGiftValidateDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data: MatchingGiftDialogData,
              private sanitizer: DomSanitizer) {
    this.dialogData = data;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getSvgImage(value) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
